import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, EsitiTipo, ModelNumStr, IEsitiTipoLng, ModelNum } from '../../models/-index';

@Injectable()
export class EsitiTipoService extends CrudGenericsService<EsitiTipo, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/EsitiTipo`);
    this.base = `${env.apiUrl}/api/EsitiTipo/`;
  }
  // ionic
  GetEsitiTipo_Codici(): Observable<ModelNumStr[]> {
    const url = this.base + 'GetEsitiTipo_Codici';
    return this.http.get<ModelNumStr[]>(`${url}`);
  }
  // web
  GetAll_EsitiTipoLng(): Observable<IEsitiTipoLng[]> {
    const url = this.base + 'GetAll_EsitiTipoLng';
    return this.http.get<IEsitiTipoLng[]>(`${url}`);
  }
  // web
  EsitiTipoSuggestNext_Sequenza(): Observable<ModelNum> {
    const url = this.base + 'EsitiTipoSuggestNext_Sequenza';
    return this.http.get<ModelNum>(`${url}`);
  }
}
